/* eslint-disable react/jsx-max-depth */ import { isEmpty } from 'lodash';
import React, { useContext, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useParams } from 'react-router-dom';
import Icon from '../../components/icon/Icon';
import Loading from '../../components/loading/Loading';
import Page from '../../components/page/Page';
import { profileSelectors } from '../../redux/selectors/profile';
import text, { formatCurrency } from '../../text';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { MapViewContext } from '../../components/mapView/mapViewContext';
import CtaButton from '../../components/RightMenu/CtaButton';
import { clearJob, getJob, setMembershipPriceId } from '../../redux/actions';
import { isMembershipPriceId } from '../../utilities/membership';
import { isStaff, isUserGovernment, isUserUnderTrial, userHasValidMembership } from '../../utilities/user';
import ForQuotation from './Invoice/ForQuotation';
import { InvoiceTotal } from './Invoice/InvoiceTotal';
import MembershipInvoice from './Invoice/MembershipInvoice';
import ProductInvoice from './Invoice/ProductInvoice';
import PaymentProvider, { PaymentContext } from './PaymentContext';
import { GST } from '../../constants/price';
import { MEMBERSHIP } from '../../constants/membership';
var Payment = function() {
    var jobId = useParams().jobId;
    var history = useHistory();
    var dispatch = useDispatch();
    var hasValidMembership = useSelector(profileSelectors.hasValidMembership);
    var _useContext = useContext(MapViewContext), buyNowData = _useContext.state.buyNowData;
    var _useContext1 = useContext(PaymentContext), activeWizardStep = _useContext1.states.activeWizardStep, wizzardFunctions = _useContext1.refs.wizzardFunctions;
    var isInProjectStep = activeWizardStep && activeWizardStep.step === 2;
    var _useSelector = useSelector(function(state) {
        return {
            userProfileState: state.profileReducer.userProfileState,
            currentUser: state.profileReducer.userProfile,
            job: state.jobsReducer.job,
            isGettingJob: state.jobsReducer.isGettingJob,
            membershipPriceId: state.order.membershipPriceId,
            membershipPrices: state.profileReducer.membershipPrices
        };
    }), userProfileState = _useSelector.userProfileState, currentUser = _useSelector.currentUser, job = _useSelector.job, isGettingJob = _useSelector.isGettingJob, membershipPriceId = _useSelector.membershipPriceId, membershipPrices = _useSelector.membershipPrices;
    useEffect(function() {
        if (jobId && isEmpty(job) && !isGettingJob) {
            dispatch(getJob(jobId));
        }
    }, [
        dispatch,
        isGettingJob,
        job,
        jobId
    ]);
    useEffect(function() {
        return function() {
            dispatch(clearJob());
        };
    }, [
        dispatch
    ]);
    var selectedMembership = useMemo(function() {
        if (membershipPrices.value) {
            return membershipPrices.value.find(function(membership) {
                return membership.id === membershipPriceId;
            });
        }
        return null;
    }, [
        membershipPriceId,
        membershipPrices
    ]);
    var numList = [
        buyNowData.length > 0,
        selectedMembership
    ].filter(function(value) {
        return !!value;
    }).length;
    var memberBuyNowDiscount = useMemo(function() {
        if (!(job === null || job === void 0 ? void 0 : job.quote)) {
            return null;
        }
        var _job_quote = job.quote, _job_quote_gst = _job_quote.gst, gst = _job_quote_gst === void 0 ? GST : _job_quote_gst, price = _job_quote.price, currency = _job_quote.currency;
        return formatCurrency(price.member_automatic_discount_total * (1 + gst / 100), currency.name, currency.scale_factor, {}, true);
    }, [
        job === null || job === void 0 ? void 0 : job.quote
    ]);
    var isFreeUser = useMemo(function() {
        if (isUserGovernment(currentUser)) return false;
        return (!userHasValidMembership(currentUser) || isUserUnderTrial(currentUser)) && !hasValidMembership;
    }, [
        currentUser,
        hasValidMembership
    ]);
    var isMembershipCtaVisible = isFreeUser && isInProjectStep && !isMembershipPriceId(membershipPriceId) && // if no membership selected from previous step (noMembership)
    memberBuyNowDiscount;
    if (userProfileState === 'loading' || isGettingJob) {
        return /*#__PURE__*/ React.createElement(Page, {
            className: "PageCenter"
        }, /*#__PURE__*/ React.createElement(Loading, null));
    }
    return /*#__PURE__*/ React.createElement(PaymentProvider, {
        job: job
    }, /*#__PURE__*/ React.createElement(Page, {
        className: "Payment"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "main-wrapper"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "invoice-wrapper"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "invoice-section"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex"
    }, /*#__PURE__*/ React.createElement(Link, {
        onClick: function() {
            return history.goBack();
        },
        className: "d-flex align-items-center",
        href: "#"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "caret-left"
    }), text('backTo2DMap'), ":")), buyNowData.length > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", {
        className: "invoice-title text-uppercase font-16 mb-3"
    }, text('buyNow'), ":"), /*#__PURE__*/ React.createElement(ProductInvoice, {
        jobId: parseInt(jobId),
        hasValidMembership: hasValidMembership,
        numOrder: numList - (numList > 1)
    })), !hasValidMembership && !isStaff(currentUser.role) && /*#__PURE__*/ React.createElement(MembershipInvoice, {
        numOrder: numList,
        isFromOrderWizard: true
    }), buyNowData.length > 0 || !hasValidMembership && !isStaff(currentUser.role) && isMembershipPriceId(membershipPriceId) ? /*#__PURE__*/ React.createElement(InvoiceTotal, {
        quote: job === null || job === void 0 ? void 0 : job.quote,
        currentUser: currentUser,
        membershipPriceId: membershipPriceId,
        selectedMembership: selectedMembership
    }) : /*#__PURE__*/ React.createElement("div", {
        className: "mt-3"
    }), isMembershipCtaVisible ? /*#__PURE__*/ React.createElement(CtaButton, {
        className: "mb-2",
        show: true,
        header: text('membership'),
        description: text('ctaMembershipSubtitle', {
            amount: "-".concat(memberBuyNowDiscount)
        }),
        titleClassNames: "pl-2 font-14",
        subTitleClassNames: "pl-2 pink font-14 font-italic mt-2",
        isTertiary: true,
        tooltip: /*#__PURE__*/ React.createElement(OverlayTrigger, {
            trigger: [
                'hover',
                'focus'
            ],
            placement: "top",
            overlay: /*#__PURE__*/ React.createElement(Tooltip, {
                id: "other-charge-tooltip"
            }, text('ctaMembershipTooltip'))
        }, /*#__PURE__*/ React.createElement(Icon, {
            icon: "question",
            className: "other-charge-icon",
            style: {
                pointerEvents: 'auto'
            }
        })),
        handleClick: function() {
            if (wizzardFunctions.current) {
                dispatch(setMembershipPriceId(MEMBERSHIP.YEARLY.PRICE_ID));
                wizzardFunctions.current.previousStep();
            }
        }
    }) : null, /*#__PURE__*/ React.createElement(ForQuotation, {
        numOrder: numList
    }))))));
};
export default Payment;
